<!--  -->
<template>
  <div class="container">
    <div class="item one">
      <div class="hint-one">姓名</div>
      <input type="text" v-model="getName" class="name f_14" placeholder="请输入姓名" />
    </div>
    <div class="item">
      <div class="hint-one">身份证</div>
      <input type="text" v-model="getIdCard" class="name f_14" placeholder="请输入身份证号码" />
    </div>
    <div class="item" @click="chooseSex ">
      <div class="hint-one">性别</div>
      <span class="name f_14">{{getSex}}</span>
      <!-- <input type="text" class="name f_14" disabled placeholder="请选择性别" /> -->
      <i class="iconfont icon-youjiantou" style="float:right"></i>
    </div>
    <div class="item one">
      <div class="hint-one">邮箱</div>
      <input type="text" v-model="getEmail" class="name f_14" placeholder="请输入邮箱地址" />
    </div>
    <div class="item" @click="chooseXueLi">
      <div class="hint-one">最高学历</div>
      <span class="name f_14">{{educationBackground}}</span>
      <!-- <input type="text" class="name f_14" placeholder="请选择" /> -->
      <i class="iconfont icon-youjiantou" style="float:right"></i>
    </div>
    <button class="apply_register" @click="applyRegister">申请注册</button>
    <van-action-sheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      @select="onSelect"
      @cancel="onCancel"
    />
    <van-action-sheet
      v-model="show2"
      :actions="actions2"
      cancel-text="取消"
      @select="onSelect2"
      @cancel="onCancel2"
    />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      getName: "",
      getIdCard: "",
      getEmail: "",
      getSex: "请选择性别",
      educationBackground: "请选择", //学历
      phone: "",
      firstPwd: "",
      secondPwd: "",
      status: null,
      show: false,
      show2: false,
      actions: [
        { name: "男", color: "#7a7a7a" },
        { name: "女", color: "#7a7a7a" }
      ],
      actions2: [
        { name: "小学", color: "#7a7a7a" },
        { name: "初中", color: "#7a7a7a" },
        { name: "高中", color: "#7a7a7a" },
        { name: "大专", color: "#7a7a7a" },
        { name: "本科", color: "#7a7a7a" },
        { name: "研究生", color: "#7a7a7a" }
      ]
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 选择性别
    chooseSex() {
      this.show = true;
    },
    // 选择绚丽
    chooseXueLi() {
      this.show2 = true;
    },
    // 申请注册
    applyRegister() {
      if (this.getName == "") {
        this.$hide
          .alert({ title: "提示", message: "姓名不能为空" })
          .then(() => {
            this.$hide.close();
          });
      } else if (this.getIdCard == "") {
        this.$hide
          .alert({ title: "提示", message: "身份证号码不能为空" })
          .then(() => {
            this.$hide.close();
          });
      } else if (this.getSex == "请选择性别") {
        this.$hide.alert({ title: "提示", message: "请选择性别" }).then(() => {
          this.$hide.close();
        });
      } else if (this.educationBackground == "请选择") {
        this.$hide.alert({ title: "提示", message: "请选择学历" }).then(() => {
          this.$hide.close();
        });
      } else {
        if (this.status == 200) {
          this.$http
            .completeUserInfo({
              realname: this.getName,
              ident: this.getIdCard,
              sex: this.getSex == "男" ? 1 : 0,
              phone: this.phone,
              email:this.getEmail,
              password: this.firstPwd,
              password_again: this.secondPwd,
              education: this.educationBackground
            })
            .then(res => {
              if (res.status == 1) {
                this.$hide
                  .alert({
                    title: "提示",
                    message: res.msg
                  })
                  .then(() => {
                    this.$router.push({ path: "/submitSuccess" });
                  });
              } else {
                this.$hide.alert({
                  title: "提示",
                  message: res.msg
                });
              }
            });
        } else {
          this.$http
            .studentRegister({
              phone: this.phone,
              ident: this.getIdCard,
              sex: this.getSex == "男" ? 1 : 0,
              email:this.getEmail,
              realname: this.getName,
              education: this.educationBackground,
              password: this.firstPwd,
              password_again: this.secondPwd
            })
            .then(res => {
              if (res.status == 1) {
                this.$hide
                  .alert({
                    title: "提示",
                    message: res.msg
                  })
                  .then(() => {
                    this.$router.push({ path: "/submitSuccess" });
                  });
              } else {
                this.$hide.alert({
                  title: "提示",
                  message: res.msg
                });
              }
            });
        }
      }
    },
    onSelect(e) {
      this.getSex = e.name;
      this.show = false;
    },
    onSelect2(e) {
      this.educationBackground = e.name;
      this.show2 = false;
    },
    onCancel() {
    },
    onCancel2() {
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.phone = this.$route.query.phone;
    this.firstPwd = this.$route.query.firstPwd;
    this.secondPwd = this.$route.query.secondPwd;
    this.status = this.$route.query.status;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #f5f5f5;
  position: relative;
  .one {
    margin-top: 10px;
  }
  .item {
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #dddddd;
    padding: 8px 18px 3px;
    box-sizing: border-box;
    .hint-one {
      color: #333333;
      width: 100%;
      font-size: 15px;
    }
    .name {
      border: none;
      height: 30px;
      display: inline-block;
      color: #999999;
      font-size: 17px;
      width: 80%;
      background-color: #fff;
      -webkit-appearance: none;
      padding: 0;
    }
    input::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: #999999;
    }
    :-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #333333;
    }
    ::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #333333;
    }
    input:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #333333;
    }
    input::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #333333;
    }
  }
  .apply_register {
    width: 90%;
    height: 44px;
    background-color: #2f85ed;
    border-radius: 22px;
    font-size: 18px;
    color: #fff;
    border: none;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 35px;
  }
}
</style>